import { call, put, takeLatest } from 'redux-saga/effects';
import { createRequestSaga } from '@/redux/helpers';
import Api from '@/api';
import { addToastsAction } from '@/redux/toasts';
import { mapErrorToastsData } from '@/lib/api';
import { toastType } from '@/components/common';
import {
  pushToAspynAsync,
  pushHousingToAspynAsync,
  seedPrerequisiteEntitiesAsync,
  clearCacheOfAspynPushesAsync,
  requestMigrationJobsAsync,
  migrateRepsAsync,
} from './actions';

function* pushToAspynSaga({ payload }) {
  try {
    const { userId } = payload;

    const response = yield call(Api.pushToAspyn, { user_id: userId });

    yield put(pushToAspynAsync.success(response));
  } catch (error) {
    yield put(pushToAspynAsync.failure(error));
    throw error;
  }
}

function* pushHousingToAspynSaga({ payload }) {
  try {
    const { recruitingSeasonId } = payload;

    const response = yield call(
      Api.pushHousingToAspyn,
      recruitingSeasonId ? { recruiting_season_id: recruitingSeasonId } : {},
    );

    yield put(pushHousingToAspynAsync.success(response));
  } catch (error) {
    yield put(pushHousingToAspynAsync.failure(error));
    throw error;
  }
}

function* seedPrerequisiteEntitiesSaga() {
  try {
    const response = yield call(Api.seedPrerequisiteEntities);

    yield put(seedPrerequisiteEntitiesAsync.success(response));
    yield put(addToastsAction([{
      type: toastType.SUCCESS,
      message: response?.message || 'Prerequisite entities were seeded successfully.',
    }]));
  } catch (error) {
    yield put(seedPrerequisiteEntitiesAsync.failure(error));
    yield put(addToastsAction(mapErrorToastsData(error)));
    throw error;
  }
}

function* clearCacheOfAspynPushesSaga() {
  try {
    const response = yield call(Api.clearCacheOfAspynPushes);

    yield put(clearCacheOfAspynPushesAsync.success(response));
    yield put(addToastsAction([{
      type: toastType.SUCCESS,
      message: response?.message || 'Cache was cleared successfully.',
    }]));
  } catch (error) {
    yield put(clearCacheOfAspynPushesAsync.failure(error));
    yield put(addToastsAction(mapErrorToastsData(error)));
    throw error;
  }
}

function* requestMigrationJobsSaga({ payload }) {
  try {
    const response = yield call(Api.getMigrationJobs, payload);

    yield put(requestMigrationJobsAsync.success(response));
  } catch (error) {
    yield put(requestMigrationJobsAsync.failure(error));
    yield put(addToastsAction(mapErrorToastsData(error)));
    throw error;
  }
}

function* migrateRepsSaga({ payload }) {
  try {
    const { userIds } = payload;

    const response = yield call(Api.migrateReps, { user_ids: userIds });

    yield put(migrateRepsAsync.success(response));
    yield put(addToastsAction([{
      type: toastType.SUCCESS,
      message: response?.message || 'Rep migration jobs were dispatched successfully.',
    }]));
  } catch (error) {
    yield put(migrateRepsAsync.failure(error));
    yield put(addToastsAction(mapErrorToastsData(error)));
    throw error;
  }
}

export function* aspynMigratorActionWatcher() {
  yield takeLatest(
    pushToAspynAsync.request,
    createRequestSaga(pushToAspynSaga, {
      keyNew: 'pushToAspyn',
      errKey: 'pushToAspyn',
    }),
  );

  yield takeLatest(
    pushHousingToAspynAsync.request,
    createRequestSaga(pushHousingToAspynSaga, {
      keyNew: 'pushHousingToAspyn',
      errKey: 'pushHousingToAspyn',
    }),
  );

  yield takeLatest(
    seedPrerequisiteEntitiesAsync.request,
    createRequestSaga(seedPrerequisiteEntitiesSaga, {
      keyNew: 'seedPrerequisiteEntities',
      errKey: 'seedPrerequisiteEntities',
    }),
  );

  yield takeLatest(
    clearCacheOfAspynPushesAsync.request,
    createRequestSaga(clearCacheOfAspynPushesSaga, {
      keyNew: 'clearCacheOfAspynPushes',
      errKey: 'clearCacheOfAspynPushes',
    }),
  );

  yield takeLatest(
    requestMigrationJobsAsync.request,
    createRequestSaga(requestMigrationJobsSaga, {
      keyNew: 'requestMigrationJobs',
      errKey: 'requestMigrationJobs',
    }),
  );

  yield takeLatest(
    migrateRepsAsync.request,
    createRequestSaga(migrateRepsSaga, {
      keyNew: 'migrateReps',
      errKey: 'migrateReps',
    }),
  );
}
